// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLEROPEDIA_NEW_ARTICLES = "Nejnov\u011bj\u0161\u00ed \u010dl\u00e1nky";
